import { Option } from '@beeline/design-system-react/extracted-styles';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { startAppListening } from '../listenerMiddleware';

import { emptyBookings, initialState } from './initialState';
import { searchBookings } from './services';

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setFrom: (state, action: PayloadAction<string | undefined>) => {
      state.from = action.payload;
    },
    setTo: (state, action: PayloadAction<string | undefined>) => {
      state.to = action.payload;
    },
    applyFilters: (
      state,
      action: PayloadAction<{
        from: string | undefined;
        to: string | undefined;
      }>,
    ) => {
      state.from = action.payload.from;
      state.to = action.payload.to;
    },
    resetFilters: state => {
      state.from = undefined;
      state.to = undefined;
    },
    setEmployee: (state, action: PayloadAction<Option<string> | null>) => {
      state.employee = action.payload;
    },
    setFiltersAreOpened: (state, action: PayloadAction<boolean>) => {
      state.filtersAreOpened = action.payload;
    },
    openFilters: state => {
      state.filtersAreOpened = true;
    },
    closeFilters: state => {
      state.filtersAreOpened = false;
    },
  },
  extraReducers(builder) {
    builder.addCase(searchBookings.pending, (state, action) => {
      if (action.meta.arg) {
        state.rows = emptyBookings;
        state.hasMore = true;
      }
      state.error = undefined;
      state.loading = true;
      state.currentRequestId = action.meta.requestId;
    });
    builder.addCase(searchBookings.rejected, (state, action) => {
      if (state.currentRequestId !== action.meta.requestId) return;

      state.error = action.payload;
      state.loading = false;
    });
    builder.addCase(searchBookings.fulfilled, (state, action) => {
      if (!action.payload || state.currentRequestId !== action.meta.requestId)
        return;

      state.loading = false;
      state.hasMore = !!action.payload.nextPageToken;
      state.token = action.payload.nextPageToken;
      state.rows = action.meta.arg
        ? action.payload.bookings
        : [...state.rows, ...action.payload.bookings];
      state.now = action.payload.now;
    });
  },
});

export const { actions: searchActions, reducer: searchReducer } = searchSlice;

startAppListening({
  predicate: (action, current, previous) => {
    return (
      current.search.from !== previous.search.from ||
      current.search.to !== previous.search.to ||
      current.search.employee?.id !== previous.search.employee?.id
    );
  },
  effect: (action, listenerApi) => {
    listenerApi.dispatch(searchBookings(true));
  },
});
